<app-keenicon
  name="arrow-up"
  type="solid"
  class="svg svg-icon fs-3"
></app-keenicon>
